import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { defer, map, Observable, shareReplay } from 'rxjs';

import { Environment, ENVIRONMENT } from '@environment';
import { UsheruApi } from '@usheru-hff/shared/data-access-backend';
import { Country } from '@usheru-hff/shared/domain';

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private readonly headers = this.usheruApi.getStandardHeader();
  constructor(
    private usheruApi: UsheruApi,
    private http: HttpClient,
    @Inject(ENVIRONMENT) private env: Environment
  ) {}

  private allCountries$ = defer(() =>
    this.http.get<Country[]>(this.env.api.countriesAllUrl(), { headers: this.headers })
  ).pipe(shareReplay(1));
  private streamingCountries$ = defer(() =>
    this.http.get<Country[]>(this.env.api.countriesUrl(), { headers: this.headers })
  ).pipe(shareReplay(1));

  getAllCountries(): Observable<Country[]> {
    return this.allCountries$;
  }

  getStreamingCountries(): Observable<Country[]> {
    return this.streamingCountries$;
  }

  getCountryByCode2(code2: string): Observable<Country | undefined> {
    return this.allCountries$.pipe(
      map(countries => countries.find(c => c.code2.toLowerCase() === code2.toLowerCase()))
    );
  }
}
